import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { promotionConstants } from "../shared/ocado-constants";

export class FilterValidators {
  public static noWhiteSpace: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const field = control.get('field')?.value;
    const operator = control.get('operator')?.value;
    const noSpaceFields = promotionConstants.noSpaceFields;

    if (field) {
      const filterObj = noSpaceFields.find(data => data.field === field);
      if (filterObj) {
        if (filterObj.operator.includes(operator)) {
          const value = control.get('value')?.value || '';
          if (value.includes(' ')) {
            control.get('value')?.setErrors({ invalidData: true });
          } else {
            control.get('value')?.setErrors(null);
          }
        } else {
          if (control.get('value')?.hasError('invalidData')) {
            control.get('value')?.setErrors({ invalidData: false });
          }
        }
      } else {
        if (control.get('value')?.hasError('invalidData')) {
          control.get('value')?.setErrors({ invalidData: false });
        }
      }
    }
    return null;
  };
  public static noBetweenSpace: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const field = control.get('field')?.value;
    const operator = control.get('operator')?.value;
    const noBetweenSpaceList = promotionConstants.noBetweenSpaceValidation;

    if (field) {
      const filterObj = noBetweenSpaceList.find(data => data.field === field);
      if (filterObj) {
        if (filterObj.operator.includes(operator)) {
          const value = control.get('value')?.value || '';
          if (value.startsWith(' ') || value.endsWith(' ')) {
            control.get('value')?.setErrors({ noBetweenSpaceValidation: true });
          } else {
            control.get('value')?.setErrors(null);
          }
        } else {
          if (control.get('value')?.hasError('noBetweenSpaceValidation')) {
            control.get('value')?.setErrors({ noBetweenSpaceValidation: false });
          }
        }
      } else {
        if (control.get('value')?.hasError('noBetweenSpaceValidation')) {
          control.get('value')?.setErrors({ noBetweenSpaceValidation: false });
        }
      }
    }
    return null;
  };

  public static requiredValue: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const field = control.get('field')?.value;
    const operator = control.get('operator')?.value;
    const notRequiredValidation = promotionConstants.notRequiredValidation;

    const value = control.get('value')?.value || '';
    if (field && operator) {
      const filterObj = notRequiredValidation.find(data => data.field === field);
      if (filterObj) {
        if (filterObj.operator.includes(operator)) {
          control.get('value')?.setErrors(null);
        } else {
          if (value === '' || value.length == 0) {
            control.get('value')?.setErrors({ notRequired: true });
          }
        }
      } else {
        if (value === '' || value.length == 0) {
          control.get('value')?.setErrors({ notRequired: true });
        }
      }
    }
    return null;
  };

  public static spaceValidation: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const inputValue = control.value;
    if (inputValue !== null) {
      if (inputValue.startsWith(' ') || inputValue.endsWith(' ')) {
        control?.setErrors({ spaceValidationCheck: true });
      } else {
        control?.setErrors(null);
      }
    }
    return null;
  };

}